import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';

function Callback() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        const { data: { session }, error } = await supabase.auth.getSession();
        
        if (error) throw error;
        
        if (session) {
          window.history.replaceState({}, document.title, window.location.pathname);
          navigate('/Commandes');
        }
      } catch (error) {
        console.error('Error handling callback:', error);
        navigate('/Login');
      }
    };

    handleAuthCallback();
  }, [navigate]);

  return <div>Chargement...</div>;
}
export default Callback;